import { toast } from "react-toastify";
import * as constantes from "../constants/constantes.js";
import { blobToBase64, donwloadFile, uploadFile } from "../helpers/helpers.jsx";
const ENDPOINT = constantes.URLAPI;
const ENDPOINTTESTUSUARIO = constantes.URL_TESTCERTIFICADO;

export const CertificadoFCursoAdmi = async ({ jwt, jsonData, dataCDN }) => {
  try {
    const res = await fetch(`${ENDPOINT}/ZADCertiicados/FCursoAdmi`, {
    //const res = await fetch(`${ENDPOINTTESTUSUARIO}/FCursoAdmi`, {
      method: "POST",
      headers: {
        "Authorization": "Bearer " + jwt,
        "Content-Type": "application/json",
        "accept": "application/json"
      },
      body: jsonData
    });

    if (!res.ok) {
      if (res.status !== 401) {
        return toast.error("Ocurrió un error en el servidor",{ autoClose: 3000});
      }
      window.localStorage.removeItem('jwt');
      window.location.reload();
      return;
    }

    const blob = await res.blob();
    const base64 = await blobToBase64(blob);
    
    dataCDN.ArchivoCodificado = "base64," + base64;
    await uploadFile(dataCDN);
    // const pdfUrl = URL.createObjectURL(blob);
    // window.open(pdfUrl, '_blank');
    return true;
  } catch (error) {
    console.error("Error:", error);
  }
};

//esv
export const ConstanciaFCursoAdmi = async ({ jwt, jsonData, dataCDN }) => {
  try {
    const res = await fetch(`${ENDPOINT}/ZADCertiicados/FCursoAdmi`, {
    //const res = await fetch(`${ENDPOINTTESTUSUARIO}/FCCursoAdmi`, {
      method: "POST",
      headers: {
        "Authorization": "Bearer " + jwt,
        "Content-Type": "application/json",
        "accept": "application/json"
      },
      body: jsonData
    });

    if (!res.ok) {
      if (res.status !== 401) {
        return toast.error("Ocurrió un error en el servidor",{ autoClose: 3000});
      }
      window.localStorage.removeItem('jwt');
      window.location.reload();
      return;
    }

    const blob = await res.blob();
    const base64 = await blobToBase64(blob);
    
    dataCDN.ArchivoCodificado = "base64," + base64;
    await uploadFile(dataCDN);
    // const pdfUrl = URL.createObjectURL(blob);
    // window.open(pdfUrl, '_blank');
    return true;
  } catch (error) {
    console.error("Error:", error);
  }
};

//esv

export const CertificadoFCursoAdmiNotas = async ({ jwt, jsonData, dataCDN, response }) => {
  try {
    const res = await fetch(`${ENDPOINT}/ZADCertiicados/FCursoAdmiNotas`, {
      method: "POST",
      headers: {
        "Authorization": "Bearer " + jwt,
        "Content-Type": "application/json",
        "accept": "application/json"
      },
      body: jsonData
    });

    if (!res.ok) {
      if (res.status !== 401) {
        return toast.error("Ocurrió un error en el servidor",{ autoClose: 3000});
      }
      window.localStorage.removeItem('jwt');
      window.location.reload();
      return;
    }

    const blob = await res.blob();
    const base64 = await blobToBase64(blob);
    dataCDN.ArchivoCodificado = "base64," + base64;
    await uploadFile(dataCDN);
    
    const pdfUrl = URL.createObjectURL(blob);
    window.open(pdfUrl, '_blank');
    await donwloadFile(response)
    return true;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const CertificadoFProgramaEspecializacion = async ({ jwt, jsonData, dataCDN }) => {
  try {
    const res = await fetch(`${ENDPOINT}/ZADCertiicados/FProgramaEspecializacion`, {
      method: "POST",
      headers: {
        "Authorization": "Bearer " + jwt,
        "Content-Type": "application/json",
        "accept": "application/json"
      },
      body: jsonData
    });

    if (!res.ok) {
      if (res.status !== 401) {
        return toast.error("Ocurrió un error en el servidor",{ autoClose: 3000});
      }
        window.localStorage.removeItem('jwt');
        window.location.reload();
        return;
    }
        const blob = await res.blob();
        const base64 = await blobToBase64(blob);
        
        dataCDN.ArchivoCodificado = "base64," + base64;
        await uploadFile(dataCDN);
        return true;
      } catch (error) {
        console.error("Error:", error);
      }
    };

export const CertificadoFProgramaEspecializacionNotas = async ({ jwt, jsonData, dataCDN, response }) => {
  try {
    const res = await fetch(`${ENDPOINT}/ZADCertiicados/FProgramaEspecializacionNotas`, {
      method: "POST",
      headers: {
        "Authorization": "Bearer " + jwt,
        "Content-Type": "application/json",
        "accept": "application/json"
      },
      body: jsonData
    });

    if (!res.ok) {
      if (res.status !== 401) {
        return toast.error("Ocurrió un error en el servidor",{ autoClose: 3000});
      }
      window.localStorage.removeItem('jwt');
      window.location.reload();
      return;
    }

    const blob = await res.blob();
    const base64 = await blobToBase64(blob);
    dataCDN.ArchivoCodificado = "base64," + base64;
    await uploadFile(dataCDN);
    
    const pdfUrl = URL.createObjectURL(blob);
    window.open(pdfUrl, '_blank');
    await donwloadFile(response)
    return true;
  } catch (error) {
    console.error("Error:", error);
  }
};

// export const CertificadoFProgramaEspecializacionNotas = async ({ jwt, jsonData }) => {
//     return await fetch(`${ENDPOINT}/ZADCertiicados/FProgramaEspecializacionNotas`, {
//       method: "POST",
//       headers: {
//         "Authorization": "Bearer " + jwt,
//         "Content-Type": "application/json",
//         "accept": "application/json"
//       },
//       body: jsonData
//     })
//       .then((res) => {
//         if (!res.ok) {
//           if (res.status === 401) {
//             window.localStorage.removeItem('jwt');
//             window.location.reload();
//           } else {
//             throw new Error("No se recibió respuesta del servidor");
//           }
//         }
//         return res.blob();
//       })
//       .then((blob) => {
//         const pdfUrl = URL.createObjectURL(blob);
//         window.open(pdfUrl, '_blank');
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       });
//   };